import { setupWorker } from 'msw';
import { handlers } from './handlers';
// This configures a Service Worker with the given request handlers.

export const worker =
  import.meta.env.VITE_MOCK === 'true'
    ? setupWorker(...handlers)
    : { start: () => {} };

if (import.meta.env.VITE_MOCK === 'true') {
  worker.start();
}
